import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=e9427dac&"
import script from "./LegalNotice.vue?vue&type=script&lang=ts&"
export * from "./LegalNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports